'use strict';

var ad_item = function () {
  var self = this;

  self.init();
  self.bind();
};


ad_item.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_item');

  jQuery(document).arrive('.ad_item', function (localSelf) {
    localSelf.init_items();
  }.bind(null, self));

};


ad_item.prototype.init = function () {
  var self = this;

  // console.log('init ad_item');

  self.init_items();

};


ad_item.prototype.init_items = function () {
  /*var self = this;*/

  // console.log('init ad_item');
  jQuery('.ad_item').each(
    function(/* index*/) {

      var element = jQuery(this);

      if (element.hasClass('st_mounted') === false) {
        // Acción Delete del menú de puntitos
        element.on('ad_item.delete',
          function(event) {

            event.preventDefault();
            // event.stopPropagation();

            var id = jQuery(this).attr('id');

            // console.log('Se ha disparado la acción de destruir el item con el id: ' + id);
            // console.log('Aquí podríamos hacer una llamada AJAX al servidor para notificar que ha sido destruido.');

          }
        );


        // Acción Duplicate del menú de puntitos
        element.on('ad_item.duplicate',
          function(event) {

            event.preventDefault();
            event.stopPropagation();

            var id = jQuery(this).attr('id');

            // console.log('Se ha disparado la acción de duplicar el item con el id: ' + id);

          }
        );


        if ( element.hasClass('has_link') ) {

          var link = element.find('.ad_item_el_link');

          link.on(
              'click',
              function (event) {

                // console.log('event.target');
                // console.log(event.target);

                var url = null;

                if (jQuery(event.target).hasClass('ad_item_el_customLink') ) {

                  // console.log('has hecho click en un link normal');

                } else {
                  event.preventDefault();
                  event.stopPropagation();


                  // console.log('click global');
                  url = jQuery(this).attr('data-href');

                }

                if (url !== null) {
                  // console.log('Vamos a ir a la url: ' + url);
                  window.location.href = url;
                }


              }
          );

        }

        element.addClass('st_mounted');
      }

    }
  );

};




jQuery( document ).ready(function() {

  window.ad_item = new ad_item();

});







